import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { P, H1, H2, H3 } from "commons";
import { getPin } from "commons/src/QueryParameter";

import { routes } from "../../helpers/RouteHelpers";
import { newPassword } from "../../components/DataOperations";
import { GoLogo, GlobalMsg, LiveChat, Support } from "../../components";
import {
    AuthButton,
    AuthBlock,
    AuthContentHolder,
    AuthTextInput,
    ButtonLoading,
    Form,
    PasswordInput
} from "./AuthComponents";

export function ResetPassword({ isLoading, location = window.location }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [registrationCode, setRegistrationCode] = useState("");

    useEffect(() => {
        if (!registrationCode) {
            setRegistrationCode(getPin(location.search));
        }
    }, [registrationCode, location]);

    const registerSubmit = e => {
        e.preventDefault();
        newPassword(username, password, registrationCode);
    };

    const isSubmitDisabled = !username || !password || !registrationCode;

    return (
        <AuthContentHolder>
            <GlobalMsg />
            <AuthBlock>
                <GoLogo />
                <H1 secondary>Reset password</H1>

                <Instructions data-testid="reset-password-instructions">
                    <P>
                        Thank you for submitting your username. A registration code will be sent to
                        you by email to allow you to reset your password. This may take up to 30
                        minutes to be received.
                    </P>
                    <P>Please click on the link in the email to return to this page.</P>
                </Instructions>

                <H2 textAlign="center" secondary>
                    Enter your details
                </H2>
                <Form onSubmit={registerSubmit} autoComplete="new-password">
                    <DummyPassword name="DummyPassword" type="password" />

                    <AuthTextInput
                        data-testid="username"
                        value={username}
                        label="Username"
                        type="text"
                        onChange={e => setUsername(e.target.value)}
                        autoComplete="new-password"
                        autoCapitalize="none"
                    />

                    <AuthTextInput
                        data-testid="registration-code"
                        value={registrationCode}
                        label="Registration code"
                        type="text"
                        onChange={e => setRegistrationCode(e.target.value)}
                        autoComplete="new-password"
                    />

                    <PasswordInput
                        username={username}
                        setPassword={setPassword}
                        autocompleteDisabled
                    />

                    <ButtonLoading displayWhen={!isLoading}>
                        <AuthButton data-testid="submit-button" disabled={isSubmitDisabled}>
                            Submit
                        </AuthButton>
                    </ButtonLoading>
                </Form>
                <BackLink textAlign="center" secondary>
                    <Link to={routes.public.login()}>Back to login?</Link>
                </BackLink>
                <Support />
                <LiveChat data-testid="live-chat" />
            </AuthBlock>
        </AuthContentHolder>
    );
}

const BackLink = styled(H3)`
    cursor: pointer;
`;

const Instructions = styled.div`
    text-align: left;
    width: 100%;
`;

const DummyPassword = styled.input`
    display: none;
`;

ResetPassword.propTypes = {
    isLoading: PropTypes.bool,
    location: PropTypes.object
};
